// client/src/lib/pageCache.ts
//
// Lightweight in-memory cache for the main list pages (dashboard / RFQ / quotations).
// Roaming between pages refetched every list from scratch, showing a spinner each time.
// Pages now SEED their initial state from here (instant paint on revisit) and still run
// their normal fetch to revalidate — so data is never stale for long and background
// polling is untouched. Not persisted to disk; lives for the session and is cleared on
// logout / session-expiry (see AuthContext).
//
// This is deliberately NOT a request-layer cache: the shared fetchers are also used by
// polling, so caching there would freeze live updates. Seeding at the page level keeps
// polling live while still killing the navigate-away-and-back spinner.

const store = new Map<string, unknown>();

export function readPageCache<T>(key: string): T | undefined {
  return store.get(key) as T | undefined;
}

export function writePageCache<T>(key: string, data: T): void {
  store.set(key, data);
}

export function clearPageCache(): void {
  store.clear();
}

// Stable cache keys — MUST match between the page that seeds and the prefetch that warms.
export const CACHE_KEYS = {
  board: 'board',
  rfqList: (status: string, page: number, search = '', sort = '') =>
    `rfqlist:${status}:${page}:${search}:${sort}`,
  quotationList: (page: number, limit: number, search = '', status = '') =>
    `quotelist:${page}:${limit}:${search}:${status}`,
};
